export default __webpack_public_path__ + "static/media/poireau-defense.56223cd3.png";